import { ReactNode, useMemo } from "react";

import { useLocalSampleSummaryParams } from "../../../hooks";
import { pathToSS } from "../../../util";
import { ANALYSIS } from "../consts";
import useNetworkReferences from "./useNetworkReferences";
import { Link } from "../../../../../components/link";
import { getMediaAddressParagraphSuffix } from "../utils";

const useMediaAddressParagraph = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data: networkReferencesData, dataReady } = useNetworkReferences();

  const mediaAddressReferences = useMemo(() => {
    if (!dataReady || !networkReferencesData?.length) return [];
    return networkReferencesData.filter(ref =>
      ref.extra?.some(e => e.source === ANALYSIS.MEDIAADDRESS)
    );
  }, [networkReferencesData, dataReady]);

  const additionalParagraphs = useMemo((): ReactNode[] => {
    if (!mediaAddressReferences.length) return [];

    const count = mediaAddressReferences.length;
    const maliciousCount = mediaAddressReferences.filter(
      ref => ref.classification === "malicious"
    ).length;

    const paragraphSuffix = getMediaAddressParagraphSuffix(maliciousCount);

    const networkRefsLink = pathToSS(
      hash,
      sourceId,
      "network_references",
      relationshipId
    );
    const separator = networkRefsLink.includes("?") ? "&" : "?";
    const linkWithFilter = `${networkRefsLink}${separator}filterSource=${encodeURIComponent(
      ANALYSIS.MEDIAADDRESS
    )}`;

    return [
      <p>
        Quishing Analysis extracted{" "}
        <Link to={linkWithFilter}>
          {count} {count === 1 ? "URI" : "URIs"}
        </Link>{" "}
        from this sample, {paragraphSuffix}.
      </p>
    ];
  }, [mediaAddressReferences, hash, sourceId, relationshipId]);

  return { additionalParagraphs };
};

export default useMediaAddressParagraph;
